import { ALL_BUTTON_POSITION_LIST } from '@/common/manager/position/button-position';
export const config = {
    value: 'locationReload',
    position: ALL_BUTTON_POSITION_LIST,
    action: () => {
        location?.reload?.();
    },
};
